import React from 'react';
import { Link } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-logo">
              <img src="/logo.svg" alt="LOGA" className="footer-logo-image" />
              <span>LOGA</span>
            </div>
            <p className="footer-description">{t('footer.description')}</p>
          </div>

          <div className="footer-column">
            <h4>{t('footer.quickLinks')}</h4>
            <ul>
              <li>
                <Link to="services" smooth={true} duration={500} offset={-80}>
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="about" smooth={true} duration={500} offset={-80}>
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="contact" smooth={true} duration={500} offset={-80}>
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>{t('footer.services')}</h4>
            <ul>
              <li>
                <Link to="services" smooth={true} duration={500} offset={-80}>
                  {t('services.webDev.title')}
                </Link>
              </li>
              <li>
                <Link to="services" smooth={true} duration={500} offset={-80}>
                  {t('services.customSoft.title')}
                </Link>
              </li>
              <li>
                <Link to="services" smooth={true} duration={500} offset={-80}>
                  {t('services.cloud.title')}
                </Link>
              </li>
              <li>
                <Link to="services" smooth={true} duration={500} offset={-80}>
                  {t('services.consulting.title')}
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>{t('footer.contact')}</h4>
            <ul className="footer-contact">
              <li>
                <a href="mailto:info@loga.hr">{t('contact.info.emailValue')}</a>
              </li>
              <li>
                <a href="tel:+385919796179">{t('contact.info.phoneValue')}</a>
              </li>
              <li>{t('contact.info.addressValue')}</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} LOGA. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;